/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeAOffIcon20Solid = forwardRef('MediaAudioVolumeAOffIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.796 1.204a1.125 1.125 0 0 0-1.591 1.592L5.409 6H4.25A2.25 2.25 0 0 0 2 8.25v3.5A2.25 2.25 0 0 0 4.25 14h3.432l4.781 4.573c.954.913 2.537.237 2.537-1.083V15.59l2.704 2.705a1.125 1.125 0 0 0 1.591-1.591l-15.5-15.5Z" }),
        React.createElement("path", { d: "M15 2.51V9.88l-5.56-5.56 3.023-2.892C13.417.514 15 1.19 15 2.51Z" })));
});
